import { render, staticRenderFns } from "./UpdateHistories.vue?vue&type=template&id=3826726e&scoped=true&"
import script from "./UpdateHistories.vue?vue&type=script&lang=js&"
export * from "./UpdateHistories.vue?vue&type=script&lang=js&"
import style0 from "./UpdateHistories.vue?vue&type=style&index=0&id=3826726e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3826726e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3826726e')) {
      api.createRecord('3826726e', component.options)
    } else {
      api.reload('3826726e', component.options)
    }
    module.hot.accept("./UpdateHistories.vue?vue&type=template&id=3826726e&scoped=true&", function () {
      api.rerender('3826726e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/UpdateHistories.vue"
export default component.exports